import { render, staticRenderFns } from "./LatestDescription.vue?vue&type=template&id=608caad0&scoped=true&"
import script from "./LatestDescription.vue?vue&type=script&lang=ts&"
export * from "./LatestDescription.vue?vue&type=script&lang=ts&"
import style0 from "./LatestDescription.vue?vue&type=style&index=0&id=608caad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608caad0",
  null
  
)

export default component.exports